import { render, staticRenderFns } from "./VendorAccountStatus.vue?vue&type=template&id=39dfef3d&scoped=true"
import script from "./VendorAccountStatus.vue?vue&type=script&lang=js"
export * from "./VendorAccountStatus.vue?vue&type=script&lang=js"
import style0 from "./VendorAccountStatus.vue?vue&type=style&index=0&id=39dfef3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dfef3d",
  null
  
)

export default component.exports